<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps(['items'])
const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}

</script>

<template>
  <div class="dialog-wrapper">
    <div class="dialog-overlay" @click="close"></div>
    <div class="dialog-box">
      <div class="dialog-header">
        <div class="dialog-header-text">Не оплачен взнос</div>
        <BaseCloseButton @click="close" />
      </div>
      <div class="dialog-content">
        <p>Покупка билетов доступна только после оплаты взноса:</p>
        <ul class="item-list">
          <li v-for="item in items" :key="item.id">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="dialog-buttons">
        <button class="button green no-margin" @click="close">OK</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.item-list {
  list-style: none;
  padding-left: 0;
}
</style>
